<ng-select
  [items]="companyService.companies$ | async"
  [placeholder]="placeholder"
  [searchable]="!authService.user?.isUserGroupProfile"
  [clearable]="false"
  [virtualScroll]="true"
  [loading]="companyService.companiesLoading"
  [minTermLength]="companyService.minLengthTerm"
  [typeahead]="companyService.companyInput$"
  typeToSearchText="{{
    'companyselect.minlength' | translate: { value: companyService.minLengthTerm }
  }}"
  [class]="class"
  [(ngModel)]="companyService.selectedCompany"
  (ngModelChange)="companyService.onSelectionChange($event)"
  required>
  <ng-template
    ng-label-tmp
    let-item="item"
    let-clear="clear">
    <span class="flex between gap-lg">
      <span class="ng-value-label">
        {{ item.fullName + ", " + item.name }}
      </span>
      <mat-icon svgIcon="chevronDown"></mat-icon>
    </span>
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm">
    <span
      style="width: 100%"
      class="ng-value-label"
      >{{ item.fullName + ", " + item.name }}</span
    >
  </ng-template>
</ng-select>
